import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ArticleCardSmall } from "./components/ArticleCardSmall/articleCardSmall";
import { ArticleCardLarge } from "./components/ArticleCardLarge/articleCardLarge";
var ArticleCard = function(param) {
    var title = param.title, topic = param.topic, creator = param.creator, backgroundImg = param.backgroundImg, pillText = param.pillText, _variant = param.variant, variant = _variant === void 0 ? "small" : _variant, isExternalImages = param.isExternalImages, ignoreSize = param.ignoreSize;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            variant === "small" && /*#__PURE__*/ _jsx(ArticleCardSmall, {
                title: title,
                topic: topic,
                creator: creator,
                backgroundImg: backgroundImg,
                pillText: pillText,
                isExternalImages: isExternalImages,
                ignoreSize: ignoreSize
            }),
            variant === "large" && /*#__PURE__*/ _jsx(ArticleCardLarge, {
                title: title,
                topic: topic,
                creator: creator,
                backgroundImg: backgroundImg,
                pillText: pillText,
                isExternalImages: isExternalImages,
                ignoreSize: ignoreSize
            })
        ]
    });
};
export default ArticleCard;
